import React, { useState } from "react"; 

const Input = ({
  icon,
  label,
  type,
  BsEyeFill,
  value,
  onChange,
  onBlur,
  name,
  BsEyeSlashFill
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  return (
    <div className="w-full">
      <label className="text-xs font-outfit font-normal leading-[10.63px]">
        {label}
      </label>
      <div className="flex items-center gap-2 rounded-xl border border-canvas-primary px-3 focus-within:ring-1 focus-within:ring-canvas-primary">
        <img src={icon} alt="icon" className="h-4 w-4" />
        <input
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          name={name}
          type={showPassword ? "text" : type}
          className="outline-none border-none w-full font-outfit bg-transparent"
        />
        <span className="cursor-pointer" onClick={togglePasswordVisibility}>{showPassword ? BsEyeFill : BsEyeSlashFill }</span>
      </div>
    </div>
  );
};

export default Input;
